const components = {
    MuiButtonBase: {
        defaultProps: {
            disableRipple: false,
        },
    },

}

export default components